import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { Router } from '@angular/router';

@Injectable()
export class UserProvider {


  public isLoggedIn:boolean = false;
  public tempSid;
  public sid; 
  public email; 
  public full_name; 
  public profile_image;
  public signature;
  public status;
  public phone;
  public id;
  public notifications;
  public isWelcomeScreen : boolean = false;
  public countryData=[];
  public tempData;
  public tempWarehouseId=0;
  public tempWarehouseData = '';
  public logoutEvent = new Subject();
  public invoice_file1;
  public invoice_file2;
  public invoice_file3;
  public invoice_file4;


  constructor(private router: Router) {}
  // store the URL so we can redirect after logging in
  redirectUrl: string;

  // Login : set data 
  login(userData): Observable<boolean> {
    this.sid = userData.sid;  
    this.email = userData.email;
    this.full_name = userData.full_name;
    this.profile_image = userData.profile_image;
    this.signature = userData.signature;
    this.status = userData.status;
    this.phone = userData.phone;
    this.tempData = userData;
    this.setData(userData);
    this.isLoggedIn = true;
    localStorage.setItem('isLoggedIn', 'true');
    return Observable.of(true).delay(100).do(val => this.isLoggedIn = true);
  }

  //Logout : clear data
  logout() {
    this.sid = "";  
    this.email = "";
    this.full_name = "";
    this.profile_image = "";
    this.signature = "";
    this.status = "";
    this.phone = "";
    this.tempData = "";
    this.removeData('UserData');
    localStorage.setItem('isLoggedIn', 'false');
    this.isLoggedIn = false;
    this.router.navigate(['/home']);
    return false;
  }

  // Update user profile
  public updateProfile (data, image) {

    let userData = this.getData();
    if(image) {
      this.profile_image = image;
      userData.profile_image = image;
    }
    this.full_name = data.full_name;
    userData.full_name = data.full_name;
    this.setData(userData);
  }

  public updateProfileImage ( image ) {

    let userData = this.getData();
    if(image) {
      this.profile_image = image;
      userData.profile_image = image;
    }
    this.setData(userData);
  }

  public updateProfileSign ( image ) {

    let userData = this.getData();
    if(image) {
      this.signature = image;
      userData.signature = image;
    }
    this.setData(userData);
  }


  setUserAddressCount(key,val){
    let userData = this.getData();
    userData.key = val;
    this.setData(userData);
  }

    /*
   * setData
   * Set the data on native storage
   * @param:- userData : required (Pass the json object data)
   */ 
  setData (userData) {
    /* if(userData.full_name!=undefined)
     this.full_name = userData.full_name;

    if(userData.phone!=undefined)
     this.phone = userData.phone; */

    localStorage.setItem('UserData', JSON.stringify(userData))
    // .then(
    // success => console.log('item stored'),
    // error => console.log(error)
    // )
  }

  /*
   * getData
   * Get data from native storage
   */ 
  getData() {
    return JSON.parse(localStorage.getItem('UserData'))
  }

  getDataPromise() {
    //return JSON.parse(localStorage.getItem('UserData'))
    //return Observable.of(true).delay(100).do(data => JSON.parse(localStorage.getItem('UserData')) );
    return of(JSON.parse(localStorage.getItem("UserData")));
  }

  /*
   * removeData
   * Remove data from the native storage
   * @param:- key : required (pass the key that you want to remove from native storage) 
   */ 
  removeData (key) {
    localStorage.setItem(key,'')
  }

  
  //******************Other User functions */


  public checkDOB (dob) {
    if(dob.indexOf('T') != -1) {
      return dob.split('T')[0];
    } else {
      return dob;
    }
  }

  sendLogoutEvent () {
    this.logoutEvent.next();
  }

  receiveLogoutEvent (): Observable<any>{
    return this.logoutEvent.asObservable();
  }

  setCountryData(data){
    this.countryData = data;
  }

  isContryData(){
    return this.countryData?true:false;
  }

  getCountry(){
    var cnt = [];
    var data = this.countryData;
    for(var i=0; i<data.length; i++){
      cnt.push({id:data[i].id, name:data[i].name});
    }
    return cnt;
  }

  getState(country_id){
    //console.log('getstate');
    //console.log(country_id);
    var data = this.countryData;
    for(var i=0; i<data.length; i++){
      if(data[i].id == country_id){
        //console.log(data[i]);
        //console.log(country_id);
        return data[i].islands;
      }
    }
  }

  pad(num, size = 3) {
    var s = num+"";
    while (s.length < size) s = "0" + s;
    return s;
  }


  setSocialData (data) {
    localStorage.setItem('socialData', JSON.stringify(data))
  }

  getSocialData() {
    return JSON.parse(localStorage.getItem('socialData'))
  }


}



// WEBPACK FOOTER //
// ./src/app/providers/user/user.ts